/* eslint-disable */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useRef } from "react";
import { IonBadge } from "@ionic/react";
import { useIonRouter } from "@ionic/react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(()=>{
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
export default function NavBar({ purpose = 'default', showSearchbar = false, hideMenu = false, ...props }) {
    const homeUrl = typeof props.homeUrl == 'undefined' ? '/' : props.homeUrl;
    const cartUrl = typeof props.cartUrl == 'undefined' ? '#' : props.cartUrl;
    const dashUrl = typeof props.dashUrl == 'undefined' ? '#' : props.dashUrl;
    const favoriteUrl = typeof props.favoriteUrl == 'undefined' ? '#' : props.favoriteUrl;
    const notificationsUrl = typeof props.notificationsUrl == 'undefined' ? '#' : props.notificationsUrl;
    const marketplaceUrl = typeof props.marketplaceUrl == 'undefined' ? '/marketplace/home' : props.marketplaceUrl;
    const sidebarDisplayed = typeof props.sidebarDisplayed === 'undefined' ? false : props.sidebarDisplayed;
    const [searchQuery, setSearchQuery] = useState('');
    const debouncedSearchQuery = useDebounce(searchQuery, 300);
    useEffect(()=>{
        if (props.onSearchDebounced) {
            props.onSearchDebounced(debouncedSearchQuery);
        }
    }, [
        debouncedSearchQuery,
        props.onSearchDebounced
    ]);
    const router = useIonRouter();
    // const navigateToMarketplace = () => {
    //   if (purpose === "default") router.push('/marketplace');
    //   else router.push('/');
    // };
    const toggleMobileMenu = (e)=>{
        e.stopPropagation();
        !sidebarDisplayed //about to open
         ? props.displaySidebar && props.displaySidebar(true) : props.displaySidebar && props.displaySidebar(false);
    };
    //cart hint updating logic
    const cartRef = useRef(null);
    useEffect(()=>{
        if (!cartRef.current) return;
        if (!isNaN(props.cartHint) && props.cartHint > 0) {
            cartRef.current.classList.add('bouncing');
            const stopTimeout = setTimeout(()=>{
                if (cartRef.current) cartRef.current.classList.remove('bouncing');
            }, 700);
            return ()=>clearTimeout(stopTimeout);
        }
    }, [
        props.cartHint
    ]);
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx("div", {
            className: "slowmo navBar w-full xlg:w-120 xlg:mx-auto xlg:px-4 py-4 lg:py-6 bg-[#001865] dark:bg-gray-800 border-b border-[#1B6392]",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between gap-3 h-full parent-container xlg:w-[calc(100%-16px)]",
                children: [
                    /*#__PURE__*/ _jsx("a", {
                        href: `https://www.swiftmedix.com`,
                        onClick: (e)=>{
                            if (props.signedIn && marketplaceUrl) {
                                e.preventDefault();
                                router.push(marketplaceUrl, 'root');
                            }
                        },
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/swiftmedix.svg",
                            alt: "Logo",
                            className: `h-5 md:h-8 w-auto cursor-pointer block`
                        })
                    }),
                    purpose == 'default' && /*#__PURE__*/ _jsx(_Fragment, {
                        children: showSearchbar && /*#__PURE__*/ _jsx("div", {
                            className: `w-1/3 lg:block lg:w-1/2 px-0`,
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "relative w-full",
                                children: [
                                    /*#__PURE__*/ _jsx(Search, {
                                        className: "absolute left-2 lg:left-3 top-1/2 -translate-y-1/2 size-4 text-gray-400"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        placeholder: "Search products & consultants",
                                        onFocus: props?.onStartSearch,
                                        onChange: (e)=>setSearchQuery(e.target.value),
                                        className: "w-full pl-8 lg:pl-10 pr-3 py-1 lg:py-2 rounded-full opacity-50 border border-gray-300  focus:outline-none focus:ring-2 focus:ring-blue-500  focus:border-transparent text-xs lg:text-sm truncate"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-[6px] lg:gap-[12px]",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: `block`,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center gap-[6px] lg:gap-[12px] font-extralight text-white font-dm_sans",
                                    children: [
                                        dashUrl && props.signedIn && props.firstName ? // Signed in: show who's logged in instead of a generic
                                        // icon — makes it obvious (without opening anything) that
                                        // there's an active session, and one tap goes straight
                                        // back to the dashboard.
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex items-center justify-center relative cursor-pointer",
                                            children: /*#__PURE__*/ _jsxs(Link, {
                                                to: dashUrl,
                                                className: "whitespace-nowrap text-sm lg:text-base font-medium text-white hover:opacity-80",
                                                children: [
                                                    "Hi, ",
                                                    props.firstName
                                                ]
                                            })
                                        }) : dashUrl && /*#__PURE__*/ _jsx("div", {
                                            className: "flex items-center justify-center relative cursor-pointer",
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                to: dashUrl,
                                                children: /*#__PURE__*/ _jsxs("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    className: "text-white size-[18px] lg:size-[22px] lucide lucide-user-round-icon lucide-user-round",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("circle", {
                                                            cx: "12",
                                                            cy: "8",
                                                            r: "5"
                                                        }),
                                                        /*#__PURE__*/ _jsx("path", {
                                                            d: "M20 21a8 8 0 0 0-16 0"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        cartUrl && /*#__PURE__*/ _jsxs("div", {
                                            ref: cartRef,
                                            className: "flex items-center justify-center relative cursor-pointer",
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    to: cartUrl,
                                                    children: /*#__PURE__*/ _jsxs("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        className: "text-white size-[18px] lg:size-[22px]",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("circle", {
                                                                cx: "8",
                                                                cy: "21",
                                                                r: "1"
                                                            }),
                                                            /*#__PURE__*/ _jsx("circle", {
                                                                cx: "19",
                                                                cy: "21",
                                                                r: "1"
                                                            }),
                                                            /*#__PURE__*/ _jsx("path", {
                                                                d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                !isNaN(props.cartHint) && props.cartHint > 0 && /*#__PURE__*/ _jsx(IonBadge, {
                                                    className: "absolute -top-2 -right-4 text-[#001865] bg-white rounded-full w-5 h-5 flex items-center justify-center font-dm_sans font-light text-xs",
                                                    children: props.cartHint
                                                })
                                            ]
                                        }),
                                        favoriteUrl && /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-center relative cursor-pointer",
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    to: favoriteUrl,
                                                    children: /*#__PURE__*/ _jsx("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        className: "text-white lucide size-[18px] lg:size-[22px] lucide-heart-icon lucide-heart",
                                                        children: /*#__PURE__*/ _jsx("path", {
                                                            d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(IonBadge, {
                                                    className: " absolute -top-2 -right-4 text-[#001865] bg-white rounded-full w-5 h-5 flex items-center justify-center font-dm_sans font-light text-xs",
                                                    children: "0"
                                                })
                                            ]
                                        }),
                                        notificationsUrl && /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-center relative cursor-pointer",
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    to: notificationsUrl,
                                                    children: /*#__PURE__*/ _jsxs("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        className: "text-white size-[18px] lg:size-[22px] lucide lucide-bell-icon lucide-bell",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("path", {
                                                                d: "M10.268 21a2 2 0 0 0 3.464 0"
                                                            }),
                                                            /*#__PURE__*/ _jsx("path", {
                                                                d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                !isNaN(props.notificationHint) && props.notificationHint > 0 && /*#__PURE__*/ _jsx(IonBadge, {
                                                    className: "absolute -top-2 -right-4 text-[#001865] bg-white rounded-full w-5 h-5 flex items-center justify-center font-dm_sans font-light text-xs",
                                                    children: props.notificationHint
                                                })
                                            ]
                                        }),
                                        homeUrl && /*#__PURE__*/ _jsx("div", {
                                            className: "flex items-center justify-center relative cursor-pointer",
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                to: homeUrl,
                                                children: /*#__PURE__*/ _jsxs("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    className: "text-white size-[18px] lg:size-[22px] lucide lucide-house-icon lucide-house",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("path", {
                                                            d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"
                                                        }),
                                                        /*#__PURE__*/ _jsx("path", {
                                                            d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            !hideMenu && /*#__PURE__*/ _jsx("div", {
                                className: "cursor-pointer lg:hidden ",
                                onClick: toggleMobileMenu,
                                children: sidebarDisplayed ? /*#__PURE__*/ _jsxs("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    className: "text-white size-[18px] lg:size-[22px] lucide lucide-x-icon lucide-x",
                                    children: [
                                        /*#__PURE__*/ _jsx("path", {
                                            d: "M18 6 6 18"
                                        }),
                                        /*#__PURE__*/ _jsx("path", {
                                            d: "m6 6 12 12"
                                        })
                                    ]
                                }) : /*#__PURE__*/ _jsxs("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    className: "text-white size-[18px] lg:size-[22px]",
                                    children: [
                                        /*#__PURE__*/ _jsx("path", {
                                            d: "M4 5h16"
                                        }),
                                        /*#__PURE__*/ _jsx("path", {
                                            d: "M4 12h16"
                                        }),
                                        /*#__PURE__*/ _jsx("path", {
                                            d: "M4 19h16"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}

//# sourceMappingURL=NavBar.js.map